import Collection from 'backbone-collection'
import Model from 'backbone-model'

export default {
    Collection: Collection.Collection,
    Model: Model.Model
}


// WEBPACK FOOTER //
// ./src/config/backbone.js